export const student = [
  { title: "Обучающемуся", type: "title" },
  {
    type: "list",
    title: "Эссе",
    icon: "doc-text-icon",
    links: [
          {
           type: "link",
           title: "Отправка эссе",
           icon: "circle-icon",
           name: "student",
           },
    ],
  },
{
    type: "list",
    title: "Расписание",
    icon: "calendar",
    links: [
          {
           type: "link",
           title: "Расписание",
           icon: "circle-icon",
           name: "schedule",
           },
    ],
  },


];
